var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1277"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1277"
    },
    "bundlingPackage": "portals-platform-reference-fe",
    "bundlingPackageVersion": "static-1.1614",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};